import { BigNumber } from 'ethers'

/**
 * Resolves the promise when the expected value changed. Will time out after 10 tries
 */
export async function waitForContractValueToChange(
  changingValue: BigNumber,
  valueCallback: () => Promise<BigNumber>,
): Promise<void> {
  let currentValue = changingValue
  let tryNumber = 1
  let interval = 200 // 200 ms

  while (currentValue.eq(changingValue)) {
    await new Promise((resolve) => setTimeout(resolve, interval))
    currentValue = await valueCallback()
    interval *= 2
    if (tryNumber++ > 10) {
      throw new Error(`waitForContractValueToChange: timeout after ${tryNumber * interval}`)
    }
  }
}
